if (process.env.NODE_ENV === "production") {
  const marca_environment = "NO_TOCAR_MARCA_ENVIRONMENT";
  if (marca_environment === "PRODUCTION") {
    window.console.log = function() {};
  }
}

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";

import store from "./store/store.js";
import "./util/Filters";

Vue.config.productionTip = false;

import "css-ripple-effect/dist/ripple.min.css";
//import "./tarjetas.css";
import "./styles.css";
import "./styles-resumen.css";

import router from "./router";

import Purecss from "purecss";

import VueStash from "vue-stash";
Vue.use(VueStash);

import Header from "@/components/Header";
Vue.component("Header", Header);

import Marco from "@/components/Marco";
Vue.component("Marco", Marco);

import MarcoPrecios from "@/components/MarcoPrecios";
Vue.component("MarcoPrecios", MarcoPrecios);

import Opciones from "@/components/Opciones";
Vue.component("Opciones", Opciones);

import Numero from "@/components/Numero";
Vue.component("Numero", Numero);

import Fecha from "@/components/Fecha";
Vue.component("Fecha", Fecha);

import Combo from "@/components/Combo";
Vue.component("Combo", Combo);

import Aviso from "@/components/Aviso";
Vue.component("Aviso", Aviso);

import Checks from "@/components/Checks";
Vue.component("Checks", Checks);

import Precios from "@/components/Precios";
Vue.component("Precios", Precios);

import DatosIdentificacion from "@/components/DatosIdentificacion";
Vue.component("DatosIdentificacion", DatosIdentificacion);

import NumPresupuesto from "@/components/NumPresupuesto";
Vue.component("NumPresupuesto", NumPresupuesto);

import Resumen from "@/components/Resumen";
Vue.component("Resumen", Resumen);

import Nav from "@/components/Nav";
Vue.component("Nav", Nav);

import Spinner from "./components/Spinner.vue";
Vue.component("Spinner", Spinner);

import DetalleGarsDeUnProducto from "./components/DetalleGarsDeUnProducto.vue";
Vue.component("DetalleGarsDeUnProducto", DetalleGarsDeUnProducto);

import GarantiasDeUnProducto from "./components/GarantiasDeUnProducto.vue";
Vue.component("GarantiasDeUnProducto", GarantiasDeUnProducto);

import PrecioDeUnProducto from "./components/PrecioDeUnProducto.vue";
Vue.component("PrecioDeUnProducto", PrecioDeUnProducto);

import SelectGarantia from "@/components/SelectGarantia";
Vue.component("SelectGarantia", SelectGarantia);

import ShowCoberturaSeleccionada from "@/components/ShowCoberturaSeleccionada";
Vue.component("ShowCoberturaSeleccionada", ShowCoberturaSeleccionada);

import ShowErrorPresupuesto from "@/components/ShowErrorPresupuesto";
Vue.component("ShowErrorPresupuesto", ShowErrorPresupuesto);

import TeLlamamos from "@/components/TeLlamamos";
Vue.component("TeLlamamos", TeLlamamos);

import PopupTemplate from "@/components/PopupTemplate";
Vue.component("PopupTemplate", PopupTemplate);

import eventBus from "@/util/EventBus.js";
Vue.prototype.$eventBus = eventBus;

import Ayuda from "@/components/Ayuda";
Vue.component("Ayuda", Ayuda);

import DatosResumenConductorHabitual from "@/components/resumen/DatosResumenConductorHabitual";
Vue.component("DatosResumenConductorHabitual", DatosResumenConductorHabitual);

import DatosResumenConductorOcasional from "@/components/resumen/DatosResumenConductorOcasional";
Vue.component("DatosResumenConductorOcasional", DatosResumenConductorOcasional);

import DatosResumenTomador from "@/components/resumen/DatosResumenTomador";
Vue.component("DatosResumenTomador", DatosResumenTomador);

import DatosResumenPropietario from "@/components/resumen/DatosResumenPropietario";
Vue.component("DatosResumenPropietario", DatosResumenPropietario);

import DatosResumenAseguradora from "@/components/resumen/DatosResumenAseguradora";
Vue.component("DatosResumenAseguradora", DatosResumenAseguradora);

import DatosResumenVehiculo from "@/components/resumen/DatosResumenVehiculo";
Vue.component("DatosResumenVehiculo", DatosResumenVehiculo);

import TusDatos from "@/components/TusDatos";
Vue.component("TusDatos", TusDatos);

import TuVehiculo from "@/components/TuVehiculo";
Vue.component("TuVehiculo", TuVehiculo);

import TuProducto from "@/components/TuProducto";
Vue.component("TuProducto", TuProducto);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  name: "MainApp",
  components: {
    App,
    Purecss
  },
  data: {
    store
  },
  render: h => h(App)
});
